import React from 'react';
import { Text, StyleSheet, Platform } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import MaskedView from '@react-native-masked-view/masked-view';

const GradientText = ({ 
    children,
    style,
    gradientColors = ["#707070", "#DDDDDD"],
    fontSize = 15,
    fontFamily = 'Slate',
    fontWeight = '500',
    lineHeight,
    textAlign = 'left',
    ...props 
}) => {
    const textStyle = [
        styles.baseText,
        {
            fontSize,
            fontFamily,
            fontWeight,
            lineHeight: lineHeight || fontSize * 1.33, // Default line height
            textAlign,
        },
        style,
    ];

    if (Platform.OS === "web") {
        // Web: use CSS gradient
        return (
            <Text
                style={[
                    textStyle,
                    {
                        backgroundImage: `linear-gradient(150deg, ${gradientColors[0]}, ${gradientColors[1]})`,
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                    }
                ]}
                {...props}
            >
                {children}
            </Text>
        );
    } else {
        // Native: use MaskedView + LinearGradient
        return (
            <MaskedView
                maskElement={
                    <Text style={textStyle}>
                        {children}
                    </Text>
                }
            >
                <LinearGradient
                    colors={gradientColors}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 0 }}
                >
                    {/* Invisible text to preserve spacing */}
                    <Text style={[textStyle, { opacity: 0 }]}>
                        {children}
                    </Text>
                </LinearGradient>
            </MaskedView>
        );
    }
};

const styles = StyleSheet.create({
    baseText: {
        // Base text styles - will be overridden by props
    },
});

export default GradientText;
